import React, { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';
import { Table, Breadcrumb } from 'react-bootstrap';
import { AiOutlinePlusCircle } from 'react-icons/ai';

import DepartementService from 'Services/DepartementService';

const DepartementIndex = () => {
    const [departements, setDepartements] = useState([]);

    useEffect(() => {
        DepartementService.getDepartements()
            .then((result) => {
                if (result.status === 200) {
                    setDepartements(result.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }, []);

    return (
        <>
            <Breadcrumb className="mt-3">
                <Breadcrumb.Item>
                    <Link to="/">Home</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    <Link to="/admin">Admin</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Departement</Breadcrumb.Item>
            </Breadcrumb>
            <div className="d-flex justify-content-between align-items-center py-2">
                <h2>Departements</h2>
                <Link to="/admin/departement/create">
                    <button className="btn btn-outline-primary btn-sm">
                        <AiOutlinePlusCircle></AiOutlinePlusCircle>
                        <span className="ml-1">New</span>
                    </button>
                </Link>
            </div>

            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Nom</th>
                        <th>CodeInterne</th>
                        <th>Edit</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {departements.length ? (
                        departements.map((departement, key) => {
                            return (
                                <tr key={key}>
                                    <td>{departement.nom}</td>
                                    <td>{departement.codeInterne}</td>
                                    <td>
                                        <Link to={`/admin/departement/edit/${departement.departementId}`}>
                                            <img
                                                src="/images/edit.svg"
                                                alt=""
                                                style={{
                                                    height: '15pt',
                                                }}
                                            />
                                        </Link>
                                    </td>
                                    <td>
                                        <Link to={`/admin/departement/delete/${departement.departementId}`}>
                                            <img
                                                src="/images/delete.svg"
                                                alt=""
                                                style={{
                                                    height: '18pt',
                                                }}
                                            />
                                        </Link>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="4">no data</td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </>
    );
};

export default DepartementIndex;
